// AdminEventi.jsx
import React, { useState, useEffect } from "react";
import { db } from "./firebase.js";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import "./AdminEventi.css";

/**
 * Usa Cloudinary (unsigned preset) - hai detto:
 * cloud_name = "do82etc8l"
 * upload_preset = "webapp_eventi"
 */

const CLOUD_NAME = "do82etc8l";
const UPLOAD_PRESET = "webapp_eventi";

export default function AdminEventi() {
  const [eventi, setEventi] = useState([]);
  const [loading, setLoading] = useState(true);

  // form fields
  const [form, setForm] = useState({
    nome: "",
    path: "",
    descrizione: "",
    data: "",
    // immagini: user può caricare file o inserire URL — gestito separatamente
  });

  // immagini (file) e preview locali
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [preview1, setPreview1] = useState(null);
  const [preview2, setPreview2] = useState(null);

  // se admin preferisce inserire URL manuale (opzionale)
  const [url1, setUrl1] = useState("");
  const [url2, setUrl2] = useState("");

  // metodo immagini: "file" oppure "url"
  const [imgMethod, setImgMethod] = useState("file");

  useEffect(() => {
    const fetchEventi = async () => {
      setLoading(true);
      try {
        const snapshot = await getDocs(collection(db, "eventi"));
        setEventi(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error("Errore fetch eventi:", err);
      }
      setLoading(false);
    };
    fetchEventi();
  }, []);

  // helper: upload singolo file su Cloudinary (unsigned)
  const uploadToCloudinary = async (file) => {
    if (!file) return null;
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", UPLOAD_PRESET);
    // cloud name non è richiesto in body ma è parte dell'endpoint URL
    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: data,
      }
    );
    if (!res.ok) {
      const txt = await res.text();
      throw new Error("Upload Cloudinary fallito: " + txt);
    }
    const json = await res.json();
    return json.secure_url;
  };

  // submit: raccoglie immagini (file o url), salva su firestore
  const handleSubmit = async (e) => {
    e?.preventDefault?.();

    if (!form.nome || !form.path) return alert("Nome e Path sono obbligatori");

    try {
      const urls = [];

      if (imgMethod === "file") {
        // carica file1 e file2 (se presenti)
        if (file1) {
          const u1 = await uploadToCloudinary(file1);
          if (u1) urls.push(u1);
        }
        if (file2) {
          const u2 = await uploadToCloudinary(file2);
          if (u2) urls.push(u2);
        }
      } else {
        // metodo url: usa gli url inseriti manualmente (se validi non vuoti)
        if (url1 && url1.trim()) urls.push(url1.trim());
        if (url2 && url2.trim()) urls.push(url2.trim());
      }

      // salva evento in Firestore
      await addDoc(collection(db, "eventi"), {
        nome: form.nome,
        path: form.path,
        descrizione: form.descrizione,
        data: form.data || "",
        immagini: urls,
        createdAt: Date.now(),
      });

      alert("Evento salvato!");
      // reset form
      setForm({ nome: "", path: "", descrizione: "", data: "" });
      setFile1(null); setFile2(null); setPreview1(null); setPreview2(null);
      setUrl1(""); setUrl2("");
      // reload eventi
      const snapshot = await getDocs(collection(db, "eventi"));
      setEventi(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error(err);
      alert("Errore durante il salvataggio: " + (err.message || err));
    }
  };

  // elimina evento
  const handleDelete = async (id) => {
    if (!window.confirm("Eliminare evento?")) return;
    try {
      await deleteDoc(doc(db, "eventi", id));
      setEventi((p) => p.filter((x) => x.id !== id));
    } catch (err) {
      console.error(err);
      alert("Errore eliminazione");
    }
  };

  // preview file
  const handleFile1 = (file) => {
    if (file) {
      setFile1(file);
      setPreview1(URL.createObjectURL(file));
    } else {
      setFile1(null); setPreview1(null);
    }
  };
  const handleFile2 = (file) => {
    if (file) {
      setFile2(file);
      setPreview2(URL.createObjectURL(file));
    } else {
      setFile2(null); setPreview2(null);
    }
  };

  return (
    <div className="admin-eventi-container">
      <h1 className="admin-eventi-title">Gestione Eventi (Admin)</h1>

      <form className="admin-eventi-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Nome evento"
          value={form.nome}
          onChange={(e) => setForm({ ...form, nome: e.target.value })}
        />
        <input
          type="text"
          placeholder="Path (es: /eventi/torneo-2025)"
          value={form.path}
          onChange={(e) => setForm({ ...form, path: e.target.value })}
        />
        <textarea
          placeholder="Descrizione"
          value={form.descrizione}
          onChange={(e) => setForm({ ...form, descrizione: e.target.value })}
        />
        <input
          type="date"
          value={form.data}
          onChange={(e) => setForm({ ...form, data: e.target.value })}
        />

        <div>
          <label>
            <input
              type="radio"
              name="imgMethod"
              value="file"
              checked={imgMethod === "file"}
              onChange={() => setImgMethod("file")}
            />{" "}
            Carica file dal dispositivo
          </label>
          {"  "}
          <label>
            <input
              type="radio"
              name="imgMethod"
              value="url"
              checked={imgMethod === "url"}
              onChange={() => setImgMethod("url")}
            />{" "}
            Inserisci URL immagine
          </label>
        </div>

        {imgMethod === "file" ? (
          <>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFile1(e.target.files[0])}
            />
            {preview1 && <img src={preview1} alt="preview1" className="preview" />}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFile2(e.target.files[0])}
            />
            {preview2 && <img src={preview2} alt="preview2" className="preview" />}
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="URL immagine 1"
              value={url1}
              onChange={(e) => setUrl1(e.target.value)}
            />
            {url1 && <img src={url1} alt="preview-url1" className="preview" />}
            <input
              type="text"
              placeholder="URL immagine 2"
              value={url2}
              onChange={(e) => setUrl2(e.target.value)}
            />
            {url2 && <img src={url2} alt="preview-url2" className="preview" />}
          </>
        )}

        <button type="submit" className="admin-button">Aggiungi Evento</button>
      </form>

      <h2>Eventi esistenti</h2>
      {loading ? <p>Caricamento...</p> : (
        <div className="admin-eventi-list">
          <table>
            <thead>
              <tr><th>Nome</th><th>Path</th><th>Data</th><th>Azioni</th></tr>
            </thead>
            <tbody>
              {eventi.map(ev => (
                <tr key={ev.id}>
                  <td>{ev.nome}</td>
                  <td>{ev.path}</td>
                  <td>{ev.data || "-"}</td>
                  <td>
                    <button className="edit-btn" onClick={() => {
                      // carica i dati nel form per eventuale modifica (semplice)
                      setForm({ nome: ev.nome || "", path: ev.path || "", descrizione: ev.descrizione || "", data: ev.data || "" });
                      if (ev.immagini && ev.immagini[0]) setPreview1(ev.immagini[0]);
                      if (ev.immagini && ev.immagini[1]) setPreview2(ev.immagini[1]);
                      setImgMethod("url"); // per mostrare preview (se url)
                    }}>Modifica</button>
                    <button className="delete-btn" onClick={() => handleDelete(ev.id)}>Elimina</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
